<template>
	<div
			v-if="catalogVersion || allowedToUpdateCatalog"
			class="sidebar-version-info"
	>
		<template v-if="catalogVersion">
			<LinkOrElement
					:to="updateCatalogRoute"
					class="catalog-version"
			>
				Catalogus: <span class="version">{{ catalogVersion }}</span>
			</LinkOrElement>
		</template>

		<button
				v-if="allowedToUpdateCatalog"
				:disabled="updatingHelpPages"
				class="update-help-pages-button"
				type="button"
				@click="updateHelpPages"
		>
				<span v-show="helpPagesUpdated" aria-hidden="true">
					<IconSvg icon="check-circle" />
				</span>

			Update ondersteunende pagina's
		</button>
	</div>
</template>

<script lang="ts" setup>
import LinkOrElement from '~/components/generic/LinkOrElement.vue';
import {computed, ref} from 'vue';
import {pageNames} from '~/lib/pageHelper';
import IconSvg from '~/components/generic/IconSvg.vue';

const props = defineProps({
		catalogVersion: {
			type: [String, null],
			default: ''
		},
		allowedToUpdateCatalog: {
			type: Boolean,
			default: false
		}
	});

	const updatingHelpPages = ref(false);

	const helpPagesUpdated = ref(false);

	const updateCatalogRoute = computed(() => {
		if (!props.allowedToUpdateCatalog) {
			return undefined;
		}

		return {
			name: pageNames.manageCatalog
		};
	});

	const updateHelpPages = async () => {
		updatingHelpPages.value = true;

		const response = await fetch('/sanity-help-pages?refresh=true');

		// Simulate a delay to show a loading state and to prevent multiple clicks.
		await new Promise(resolve => setTimeout(resolve, 1000));

		updatingHelpPages.value = false;

		if (response.ok) {
			helpPagesUpdated.value = true;
			await new Promise(resolve => setTimeout(resolve, 3000));
			helpPagesUpdated.value = false;
		} else {
			console.error('Failed to update help pages');
		}
	};
</script>

<style scoped>
	.update-help-pages-button {
		background: none;
		border: none;
		padding: 3px;
		margin: 10px 0;
		font-size: var(--font-size-p-1);
		color: var(--color-grey-200);
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}

		&:disabled {
			color: var(--color-grey-50);
		}

		:deep(.check-circle-icon svg) {
			color: green;
			width: 18px;
			height: 18px;
		}
	}

	.sidebar-version-info {
		margin-top: auto;
		text-align: center;
		font-size: var(--font-size-p-1);
		color: var(--color-grey-200);
		padding: var(--spacing-3);

		a {
			color: inherit;
			text-decoration: none;

			&:hover {
				text-decoration: underline;
			}
		}
	}

	.version {
		display: inline-block;
		text-decoration: inherit;
	}
</style>
